import React, { Component } from 'react';
import { compose, graphql, withApollo } from 'react-apollo';
import { withProps } from 'recompose';
import { Table, Breadcrumb } from 'antd';
import AntIcon from '../shared/components/AntIcon';
import { Link } from 'react-router-dom';

import moment from 'moment';
import _ from 'lodash';

import {
  FeaturedContentQuery,
  UpdateArticleOrderPriorityMutation,
  UpdateReleaseOrderPriorityMutation,
} from './queries';

const ImageStyle = { objectFit: 'cover', height: 100, width: 160 };
const TypePaths = { Article: 'news', Release: 'releases' };

class List extends Component {
  constructor(props) {
    super(props);

    this.state = { priorityUpdate: { loading: false, error: null } };

    this.handlePriorityUpdate = this.handlePriorityUpdate.bind(this);
  }

  UNSAFE_componentWillReceiveProps({ content, client }) {
    if (content && !this.state.priorityUpdate.loading) {
      this.setState({ priorityUpdate: { loading: true } });
      const maxPriority = _(content).map('featuredOrderPriority').max() || 0;
      const { mutations } = content
        .filter(c => c.featuredOrderPriority == null)
        .reduce(({ mutations, maxPriority }, { _id, type }) => {
          const data = {
            variables: { id: _id, priority: maxPriority },
            mutation: type === 'Article'
              ? UpdateArticleOrderPriorityMutation : UpdateReleaseOrderPriorityMutation,
          };
          return { mutations: mutations.concat(data), maxPriority: maxPriority + 100 };
        }, { mutations: [], maxPriority: maxPriority + 100 });
      Promise.all(mutations.map((mutation) => client.mutate(mutation)))
        .then(() => this.setState({ priorityUpdate: { loading: false } }))
        .catch(error => this.setState({ priorityUpdate: { error } }));
    }
  }

  handlePriorityUpdate(idx, change) {
    const { client, content } = this.props;
    const { type, _id } = content[idx];
    const [before, after] = change === 'up'
      ? [content[idx - 2], content[idx - 1]]
      : [content[idx + 1], content[idx + 2]]

    if ((change === 'up' && !after) || (change === 'down' && !before)) return;

    const beforePriority = before ? before.featuredOrderPriority : after.featuredOrderPriority + 200;
    const afterPriority = after ? after.featuredOrderPriority : before.featuredOrderPriority - 200;
    client.mutate({
      mutation: type === 'Article'
        ? UpdateArticleOrderPriorityMutation : UpdateReleaseOrderPriorityMutation,
      variables: { id: _id, priority: (beforePriority + afterPriority) / 2 },
    })
      .catch(e => alert(`Failed to change ordering: ${e.message}.`));
  }

  render() {
    const { data, content } = this.props;
    const { priorityUpdate } = this.state;
    const error = data.error || priorityUpdate.error;
    if (error) return `Error: ${error}`;

    const makeButtonProps = (idx, change) => {
      return {
        key: change, type: `arrow-${change}`,
        style: { cursor: 'pointer' },
        onClick: () => this.handlePriorityUpdate(idx, change),
      }
    }

    const columns = [
      {
        title: '',
        dataIndex: 'featuredOrderPriority',
        width: 100,
        render: (priority, _, idx) => {
          return ([
            <AntIcon {...makeButtonProps(idx, 'up')} />,
            <AntIcon {...makeButtonProps(idx, 'down')} />,
          ]);
        },
      },
      {
        title: 'Type',
        width: 130,
        dataIndex: 'type',
      },
      {
        title: 'Image',
        dataIndex: 'image',
        width: 160,
        render: (link, { title }) => <img alt={title} style={ImageStyle} src={link} />,
      },
      {
        title: 'Title',
        dataIndex: 'title',
        width: 400,
        render: (text, record) => <Link to={`/${TypePaths[record.type]}/${record._id}/edit`}>{text}</Link>,
      },
      {
        title: 'Date',
        dataIndex: 'date',
        width: 150,
        render: (date, record) => moment.utc(date).format(record.hasUnknownDay ? "MMM Y" : "ll"),
      },
    ];

    return (
      <div id="featured-list">
        <Breadcrumb>
          <Breadcrumb.Item>Featured Content</Breadcrumb.Item>
        </Breadcrumb>

        <div className="container">
          <h4>
            Manage Featured Content
          </h4>

          <Table
            scroll={{ x: 1000 }}
            loading={false} // || data.loading || priorityUpdate.loading}
            columns={columns}
            rowKey='_id'
            dataSource={content}
            pagination={false}
          />
        </div>
      </div>
    );
  }
}

export default compose(
  graphql(
    FeaturedContentQuery,
    { options: { fetchPolicy: 'cache-and-network' } },
  ),
  withApollo,
  withProps(({ data: { loading, Releases, Articles } }) => {
    if (loading) return {};
    const releases = _.map(Releases, ({ imageUrls, ...release }) => ({
      type: 'Release', ...release, image: _.first(imageUrls),
    }));
    const articles = _.map(Articles, (article) => ({ type: 'Article', ...article }));
    const content = _(releases).concat(articles).sortBy('featuredOrderPriority').reverse().value();
    return { content };
  }),
)(List);
